import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { Checkbox, Modal } from 'antd';
import Button from 'components/Button/Button';
import RestaurantMultipleSelect from './RestaurantMultipleSelect/RestaurantMultipleSelect';
import {
	ChangeGamePositionContext,
	IChangeGamePositionContext,
} from '../../../../changeGamePositionState/changeGamePositionContext';
import classNames from 'classnames';
import style from './AdditionalRestaurantsModal.module.scss';

const AdditionalRestaurantsModal: React.FC = () => {
	const {
		setVisibleAdditionalRestaurantsModal,
		changeTypeOfModalWindow,
		toggleApplyToOne,
		isVisibleAdditionalRestaurantsModal,
		isApplyToOne,
		selectedAdditionalRestaurants,
	} = useContext<IChangeGamePositionContext>(ChangeGamePositionContext);

	const checkBoxClasses = classNames(style.checkBox, { [style.active]: isApplyToOne });
	const buttonClasses = classNames(style.saveBtn, {
		[style.visible]: isApplyToOne || selectedAdditionalRestaurants.length,
	});

	useEffect(() => {
		return () => {
			if (isApplyToOne) {
				toggleApplyToOne();
			}
		};
	}, []);

	const handleSave = async () => {
		setVisibleAdditionalRestaurantsModal(false);
		changeTypeOfModalWindow('toConfirmSave');
	};

	return (
		<Modal
			bodyStyle={{ padding: '24px 0 0 0' }}
			className={style.modalContainer}
			visible={isVisibleAdditionalRestaurantsModal}
			onCancel={() => setVisibleAdditionalRestaurantsModal(false)}
			width="50%"
			closeIcon={
				<svg className={style.closeIcon}>
					<use xlinkHref={`${breadcrumbs}#crossMark`} />
				</svg>
			}
			centered={true}
			destroyOnClose={true}
			footer={null}
			data-test="AdditionalRestaurantsModal">
			<div className={style.container}>
				<Text
					className={style.modalHeader}
					translationNameSpace="form"
					translationKey="saveChangeOnRestaurantsTitle"
					size="xxl"
					weight="bold"
					align="center"
				/>
				<div className={style.fieldWrapper}>
					<Text
						className={style.heading}
						translationNameSpace="form"
						translationKey="changesAppliesHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<Checkbox className={checkBoxClasses} checked={isApplyToOne} onChange={toggleApplyToOne}>
						<Text
							translationNameSpace="form"
							translationKey="changesAppliesToRestaurantLabel"
							asFragment={true}
						/>
					</Checkbox>
				</div>
				<div className={style.fieldWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<Text
						className={style.hint}
						translationNameSpace="form"
						translationKey="restaurantSelectHint"
						theme="secondaryLight"
						size="s"
						weight="bold"
					/>
					<RestaurantMultipleSelect />
				</div>
				<Button className={buttonClasses} theme="primaryBlue" onClick={handleSave}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Modal>
	);
};

export default AdditionalRestaurantsModal;
